import styled from '@emotion/styled';
import { List, Link, ListItem } from 'roo-ui/components';
import { themeGet } from 'styled-system';

export const HeaderListItem = styled(ListItem)`
  list-style-type: none;
  margin: 0;
  border-bottom: 1px solid ${themeGet('colors.white')};
`;

export const HeaderInternalLink = styled(Link)`
  color: ${themeGet('colors.white')};
  white-space: nowrap;
  padding: ${themeGet('space.4')} ${themeGet('space.5')};
  &:hover {
    color: ${themeGet('colors.white')};
  }
`;

export const HeaderList = styled(List)`
  display: inherit;
  margin: 0;
  padding-left: 0;
`;
